import React, { useContext, useEffect, useState } from "react";
import FavoriteConversationsContext from "../../contexts/data/FavoriteConversationsContext";
import { Table, Spin, Button, Tag } from "antd";
import { CONTACTS_PAGE_PATH } from "../../pages/contacts/ContactsPage";
import { ReloadOutlined } from "@ant-design/icons";
import { getInterestLevel } from '@leedpulse-monorepo/utils';
import { ContextStatus } from "@leedpulse-monorepo/enums";
import { advancedOnRow, getTagColor } from "../../../core/utils/commonUtils";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { IContact } from "@leedpulse-monorepo/interfaces";

const FavoriteConversations: React.FC = () => {
  const { items, status, fetchFavorites, reset } = useContext(
    FavoriteConversationsContext
  );
  const navigate = useNavigate();
  const [hasRefreshed, setHasRefreshed] = useState(false);

  useEffect(() => {
    fetchFavorites();
    return () => {
      reset();
    };
  }, []);

  const handleRefresh = () => {
    setHasRefreshed(true);
    fetchFavorites();
    setHasRefreshed(false);
  };

  return (
    <div>
      <div style={{ marginBottom: "1rem", textAlign: "right" }}>
        <Button
          type="primary"
          icon={<ReloadOutlined />}
          loading={hasRefreshed}
          onClick={handleRefresh}
        >
          Rafraîchir
        </Button>
      </div>
      {status === ContextStatus.LOADING ? (
        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Table
          dataSource={items}
          rowKey="id"
          locale={{
            emptyText: "Aucune conversation en favoris.",
          }}
          pagination={{ pageSize: 10, position: ['bottomRight', 'topRight'] }}
          columns={[
            {
              title: "Nom complet",
              dataIndex: "contact",
              key: "contact",
              render: (contact: IContact['contact']) =>
                `${contact.firstname} ${contact.lastname}`,
            },
            {
              title: "Téléphone",
              dataIndex: "contact",
              key: "phone",
              render: (contact: IContact['contact']) => contact.phone,
            },
            {
              title: "Qualification",
              dataIndex: "qualification_ai",
              key: "qualification",
              render: (qualification_ai: IContact['qualification_ai']) => (
                <Tag
                  color={getTagColor(
                    qualification_ai.qualification || "not_available"
                  )}
                >
                  {getInterestLevel(
                    qualification_ai.qualification || "not_available"
                  )}
                </Tag>
              ),
            },
            {
              title: "Dernière activité",
              dataIndex: "updated",
              key: "updated",
              render: (updated: IContact['updated']) => moment(updated).fromNow(),
            }
          ]}
          onRow={(record) =>
            advancedOnRow({
              url: `${CONTACTS_PAGE_PATH}/${record.id}/chat`,
              navigate,
              className: 'table-row',
            })
          }
        />
      )}
    </div>
  );
};

export default FavoriteConversations;
